module.exports = __webpack_public_path__ + "img/save.f63ab3e0.png";